import React, { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";
import Div from "../../components/common/Div";

// Define the keyframes for the fade-in animation
const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

// Define the styled component outside of the functional component
interface StyledModalDisplayProps {
  display: string;
}

const StyledModalDisplay = styled.div<StyledModalDisplayProps>`
  position: fixed;
  display: ${(props) => props.display};
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.9);
  border-radius: 3px;
  z-index: 99999999;
  animation: ${fadeIn} 0.5s ease-in-out;
`;

export default function ModalDisplay(props) {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <StyledModalDisplay display={props.display}>
      <Div
        backgroundColor={"#fbcd02"}
        margin={"0"}
        width={windowWidth >= 800 ? "30%" : "80%"}
        padding={"10px"}
        top={"50%"}
        left={"50%"}
        position={"absolute"}
        transform={"translate(-50%, -50%)"}
        borderRadius={"8px"}
        border={"5px"}
        zIndex={"0"}
        boxShadow={"0 4px 10px rgba(0, 0, 0, 0.1)"}
      >
        {props.children}
      </Div>
    </StyledModalDisplay>
  );
}
